import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';


const AccountInformation = ({ settings, memberColor, onChange }) => {
  const [validationErrors, setValidationErrors] = useState({});

  const privacyOptions = [
    { value: 'family', label: 'Family Only' },
    { value: 'private', label: 'Private' },
    { value: 'public', label: 'Public' }
  ];

  const handleFieldChange = (field, value) => {
    onChange({ [field]: value });
    
    if (field === 'email' && value) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex?.test(value)) {
        setValidationErrors(prev => ({ ...prev, email: 'Invalid email format' }));
      } else {
        setValidationErrors(prev => ({ ...prev, email: null }));
      }
    }
    
    if (field === 'phone' && value) {
      const phoneRegex = /^[0-9\-\+\(\)\s]+$/;
      if (!phoneRegex?.test(value)) {
        setValidationErrors(prev => ({ ...prev, phone: 'Invalid phone format' }));
      } else {
        setValidationErrors(prev => ({ ...prev, phone: null }));
      }
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center gap-2">
          <Icon name="user" size={20} style={{ color: memberColor }} />
          Personal Details
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            label="Full Name"
            value={settings?.name || ''}
            onChange={(e) => handleFieldChange('name', e?.target?.value)}
            required
          />
          <Input
            label="Role in Family"
            value={settings?.role || ''}
            onChange={(e) => handleFieldChange('role', e?.target?.value)}
          />
        </div>
      </div>

      <div>
        <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center gap-2">
          <Icon name="mail" size={20} style={{ color: memberColor }} />
          Contact Preferences
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            label="Email Address"
            type="email"
            value={settings?.email || ''}
            onChange={(e) => handleFieldChange('email', e?.target?.value)}
            error={validationErrors?.email}
            description="Used for notifications and updates"
          />
          <Input
            label="Phone Number"
            type="tel"
            value={settings?.phone || ''}
            onChange={(e) => handleFieldChange('phone', e?.target?.value)}
            error={validationErrors?.phone}
            description="Optional for SMS notifications"
          />
        </div>
      </div>
    </div>
  );
};

export default AccountInformation;